import { escH, imprimirHTML } from './comun';

/* Impresión del Certificado de Evaluación Médica Ocupacional (SNS-MSP/Form.HCU081/2025, anexo 3 del AM MSP 00025-2025).
   Se imprimen DOS originales (uno para el archivo, otro para el trabajador), cada uno en su hoja A4.
   `cert` es lo que devuelve el servidor: { NUMERO, CONTENIDO, FIRMA_PROF, FIRMA_TRAB, HASH_CONTENIDO, ESTADO }. */

const IMG = /^data:image\/(png|jpe?g);base64,[A-Za-z0-9+/=]+$/;
const X = (on) => `<span class="cb">${on ? '✕' : ''}</span>`;
const fecha = f => { const [a, m, d] = String(f || '').slice(0, 10).split('-'); return { a: a || '', m: m || '', d: d || '' }; };
const caja = (n, v) => `<span class="fch">${escH(v)}</span>`;

function hoja(cert, copia) {
  const c = cert.CONTENIDO || {}; const a = c.a || {}; const b = c.b || {}; const cc = c.c || {}; const d = c.d || {}; const e = c.e || {};
  const f = fecha(b.fecha_emision);
  const firmaProf = cert.FIRMA_PROF && IMG.test(cert.FIRMA_PROF) ? `<img src="${cert.FIRMA_PROF}" alt="Firma del profesional">` : '';
  const firmaTrab = cert.FIRMA_TRAB && IMG.test(cert.FIRMA_TRAB) ? `<img src="${cert.FIRMA_TRAB}" alt="Firma del trabajador">` : '';
  const apt = cc.aptitud;
  return `<section class="hoja">
  ${cert.ESTADO === 'ANULADO' ? '<div class="anulado">ANULADO</div>' : ''}
  <div class="tit">CERTIFICADO - EVALUACIÓN MÉDICA OCUPACIONAL</div>
  <div class="sec">A. DATOS DEL ESTABLECIMIENTO - DATOS DEL USUARIO</div>
  <table class="g"><tr>
    <td style="width:15%"><span class="l">Institución del sistema</span>${escH(a.institucion || '')}</td>
    <td style="width:16%"><span class="l">RUC</span>${escH(a.ruc)}</td>
    <td style="width:9%"><span class="l">CIIU</span>${escH(a.ciiu)}</td>
    <td style="width:26%"><span class="l">Establecimiento / centro de trabajo</span>${escH(a.establecimiento)}</td>
    <td style="width:19%"><span class="l">Número de historia clínica</span>${escH(a.hc)}</td>
    <td style="width:15%"><span class="l">Número de archivo</span>${escH(a.archivo || '')}</td></tr></table>
  <table class="g"><tr>
    <td style="width:17%"><span class="l">Primer apellido</span>${escH(a.apellido1)}</td>
    <td style="width:17%"><span class="l">Segundo apellido</span>${escH(a.apellido2)}</td>
    <td style="width:15%"><span class="l">Primer nombre</span>${escH(a.nombre1)}</td>
    <td style="width:15%"><span class="l">Segundo nombre</span>${escH(a.nombre2)}</td>
    <td style="width:10%"><span class="l">Sexo</span>H ${X(a.sexo === 'H')} &nbsp; M ${X(a.sexo === 'M')}</td>
    <td style="width:26%"><span class="l">Puesto de trabajo (CIUO)</span>${escH(a.puesto)}${a.ciuo ? ' (' + escH(a.ciuo) + ')' : ''}</td></tr></table>
  <div class="sec">B. DATOS GENERALES</div>
  <table class="g"><tr>
    <td style="width:40%"><span class="l">Fecha de emisión</span><span class="fechas"><i>aaaa</i>${caja(0, f.a)}<i>mm</i>${caja(0, f.m)}<i>dd</i>${caja(0, f.d)}</span></td>
    <td><span class="l">Evaluación</span>INGRESO ${X(b.tipo === 'INGRESO')} &nbsp; PERIÓDICO ${X(b.tipo === 'PERIODICO')} &nbsp; REINTEGRO ${X(b.tipo === 'REINTEGRO')} &nbsp; RETIRO ${X(b.tipo === 'RETIRO')}</td></tr></table>
  <div class="sec">C. APTITUD MÉDICA PARA EL TRABAJO</div>
  <div class="p">Después de la valoración médica ocupacional se certifica que la persona en mención, es calificada como:</div>
  <table class="g"><tr>
    <td>APTO ${X(apt === 'APTO')}</td><td>APTO EN OBSERVACIÓN ${X(apt === 'OBSERVACION')}</td>
    <td>APTO CON LIMITACIONES ${X(apt === 'LIMITACIONES')}</td><td>NO APTO ${X(apt === 'NO_APTO')}</td></tr></table>
  <div class="caja"><span class="l">Detalle de observaciones</span>${escH(cc.detalle || '')}</div>
  <div class="sec">D. RECOMENDACIONES/OBSERVACIONES</div>
  <div class="caja alta"><span class="l">Descripción</span>${escH(d.descripcion || '').replace(/\n/g, '<br>')}</div>
  <div class="caja"><span class="l">Observación</span>${escH(d.observacion || '')}</div>
  <div class="p t">${escH(c.texto || '')}</div>
  <div class="p t">La presente certificación se expide con base en el formulario de Evaluación Ocupacional, el cual tiene carácter de confidencial.</div>
  <table class="g fin"><tr>
    <th colspan="3" style="width:68%">E. DATOS DEL PROFESIONAL</th><th style="width:32%">F. FIRMA O HUELLA DEL TRABAJADOR</th></tr>
    <tr><td style="width:26%"><span class="l">Nombre y apellido</span>${escH(e.nombre)}${e.cedula ? '<br><small>C.I. ' + escH(e.cedula) + '</small>' : ''}</td>
    <td style="width:16%"><span class="l">Código médico</span>${escH(e.codigo_medico)}</td>
    <td style="width:26%" class="firma"><span class="l">Firma y sello</span><div class="fi">${firmaProf}</div></td>
    <td class="firma"><div class="fi" style="margin-top:12px">${firmaTrab}</div></td></tr></table>
  <div class="pie"><span>SNS-MSP/Form.HCU081/2025</span><span>Evaluación Médica Ocupacional</span></div>
  <div class="ctl">Certificado N.º ${escH(cert.NUMERO || '')} · Original ${copia === 1 ? '1 de 2 (archivo)' : '2 de 2 (trabajador)'} · Huella SHA-256: ${escH(cert.HASH_CONTENIDO || '')}</div>
</section>`;
}

export function htmlCertificado(cert) {
  return `<!doctype html><html lang="es"><head><meta charset="utf-8"><title>${escH('Certificado ' + (cert.NUMERO || ''))}</title><style>
@page{size:A4;margin:10mm}
*{box-sizing:border-box}
body{font-family:Arial,Helvetica,sans-serif;font-size:8.6pt;color:#000;margin:0}
.hoja{position:relative;page-break-after:always;border:1px solid #000;padding:0}
.hoja:last-child{page-break-after:auto}
.tit{background:#d9d9d9;text-align:center;font-weight:bold;font-size:11pt;padding:6px;border-bottom:1px solid #000}
.sec{background:#b7c9e2;font-weight:bold;padding:3px 6px;border-top:1px solid #000;border-bottom:1px solid #000;font-size:8.6pt}
table.g{width:100%;border-collapse:collapse}
table.g td,table.g th{border:1px solid #000;padding:3px 5px;vertical-align:top;font-size:8.6pt}
table.g th{background:#b7c9e2;text-align:left}
.l{display:block;font-size:6.8pt;font-weight:bold;text-transform:uppercase;color:#333;margin-bottom:2px}
.cb{display:inline-block;width:13px;height:13px;border:1px solid #000;text-align:center;line-height:12px;font-weight:bold;font-size:10px;vertical-align:middle}
.fechas i{font-style:normal;font-size:7pt;margin:0 3px 0 8px}
.fch{display:inline-block;min-width:26px;border:1px solid #000;text-align:center;padding:1px 4px;font-weight:bold}
.p{padding:5px 8px}
.t{padding:6px 8px;text-align:justify}
.caja{border-top:1px solid #000;padding:4px 8px;min-height:34px}
.caja.alta{min-height:150px}
.fi{height:62px;display:flex;align-items:center;justify-content:center}
.fi img{max-height:60px;max-width:100%}
table.fin td.firma{height:80px}
.pie{display:flex;justify-content:space-between;border-top:1px solid #000;padding:3px 8px;font-size:7.5pt}
.ctl{font:6.5pt/1.3 'Courier New',monospace;color:#333;padding:3px 8px;border-top:1px dotted #888;word-break:break-all}
.anulado{position:absolute;top:38%;left:12%;font-size:80pt;font-weight:bold;color:rgba(190,30,30,.28);transform:rotate(-24deg);pointer-events:none}
</style></head><body>${hoja(cert, 1)}${hoja(cert, 2)}</body></html>`;
}

export function imprimirCertificado(cert) {
  imprimirHTML(htmlCertificado(cert), 'Certificado ' + (cert.NUMERO || '') + ' - ' + ((cert.CONTENIDO && cert.CONTENIDO.a) ? `${cert.CONTENIDO.a.apellido1} ${cert.CONTENIDO.a.nombre1}` : '').trim());
}
